import React from 'react';
import styled from 'styled-components';
import { ToolMode } from '~admin/store/create-edit-event-flow-store';
import { CreateEditEventFlowStoreProvider } from '~admin/store/create-edit-event-flow-store-provider';
import { CreateEvent } from '~admin/view/components/create-event/create-event.component';
import { Column } from '~common/components/column.component';
import { ScrollBar } from '~web/view/theme/utils';

export const CreateEventPage: React.FunctionComponent = () => {
  return (
    <Container>
      <CreateEditEventFlowStoreProvider mode={ToolMode.CREATE}>
        <CreateEvent />
      </CreateEditEventFlowStoreProvider>
    </Container>
  );
};

// TODO(Dmitry): Move to theme
const Container = styled(Column)`
  height: 100%;
  width: 100%;
  align-items: center;
  ${ScrollBar};
`;



// WEBPACK FOOTER //
// ./view/pages/create-event.page.tsx